import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b30ccb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-sku-box" }
const _hoisted_2 = { class: "change-title-box" }
const _hoisted_3 = { class: "change-content-box" }
const _hoisted_4 = {
  key: 0,
  class: "tip-text"
}
const _hoisted_5 = { class: "change-button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, "修改库存" + _toDisplayString(_ctx.skuTitle), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ui_form, { ref: "form" }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_form_item, {
            label: "方向",
            showError: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.postData.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postData.type) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("增加")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("减少")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ui_form_item, {
            label: "数量",
            data: _ctx.postData.stock,
            required: true,
            showError: false,
            rule: _ctx.validateStock
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.postData.stock,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postData.stock) = $event)),
                validate: "int"
              }, null, 8, ["modelValue"]),
              (_ctx.postData.type == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "减少不会把库存扣成负数，不够会直接失败"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data", "rule"])
        ]),
        _: 1
      }, 512)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        onClick: _ctx.confirm
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      }, 8, ["onClick"])), [
        [_directive_loading, _ctx.submitLoading]
      ]),
      _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}